import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmissionStage, ExtendedTruckSize, TruckSize, VEHICLE_ID_PATTERN } from '../../../../../../../common/constants';
import { ControlProperty } from '../../../../../../../common/models';
import { mustNotBeBlankValidator } from '../../../../../../../common/utils';
import { TruckLoadingType } from '../../../../../administration';
import { AllocationViewUliCarrierForm, AllocationViewUliCarrierModel } from '../carrier/allocation-carrier.model';

class AllocationViewUliTruckInformationBaseModel {
  trailerPlateId: string = null;
  trailerPlateIdCountryOfOrigin: string = null;
  truckPlateId: string = null;
  truckPlateIdCountryOfOrigin: string = null;
  swapBody = false;
  customsGoods = false;
  dangerousGoods: boolean;
  truckSize: TruckSize | ExtendedTruckSize = null;
  truckId = 0;
  carrier: AllocationViewUliCarrierModel = null;
  propertyOfAnother = false;
  truckToCouple: number;
  coupling: boolean;
  decoupling: boolean;
  emissionStage: EmissionStage;

  constructor(params?: AllocationViewUliTruckInformationModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewUliTruckInformationModel {
  trailerPlateId: string = null;
  trailerPlateIdCountryOfOrigin: string = null;
  truckPlateId: string = null;
  truckPlateIdCountryOfOrigin: string = null;
  swapBody = false;
  customsGoods = false;
  dangerousGoods: boolean;
  truckSize: TruckSize | ExtendedTruckSize = null;
  truckId = 0;
  loadingTypes: TruckLoadingType[] = [];
  emissionStage: EmissionStage;

  constructor(params?: AllocationViewUliTruckInformationModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewUliTruckInformationForm {
  constructor(
    model: AllocationViewUliTruckInformationFormInputModel,
    fb: FormBuilder,
    public loadingTypes: ControlProperty<TruckLoadingType[]> = [model.loadingTypes, [Validators.required]],
    public truckPlateId: ControlProperty<string> = [
      model.truckPlateId,
      [Validators.required, mustNotBeBlankValidator, Validators.pattern(VEHICLE_ID_PATTERN)],
    ],
    public trailerPlateId: ControlProperty<string> = [
      model.trailerPlateId,
      [Validators.required, mustNotBeBlankValidator, Validators.pattern(VEHICLE_ID_PATTERN)],
    ],
    public truckPlateIdCountryOfOrigin: ControlProperty<string> = [
      model.truckPlateIdCountryOfOrigin,
      [Validators.required],
    ],
    public trailerPlateIdCountryOfOrigin: ControlProperty<string> = [
      model.trailerPlateIdCountryOfOrigin,
      [Validators.required],
    ],
    public swapBody: ControlProperty<boolean> = model.swapBody,
    public customsGoods: ControlProperty<boolean> = model.customsGoods,
    public dangerousGoods: ControlProperty<boolean> = model.dangerousGoods,
    public truckSize: ControlProperty<TruckSize | ExtendedTruckSize> = model.truckSize,
    public truckId: ControlProperty<number> = model.truckId,
    public carrier: FormGroup = fb.group(new AllocationViewUliCarrierForm(model.carrier), [Validators.required]),
    public propertyOfAnother: ControlProperty<boolean> = model.propertyOfAnother,
    public truckToCouple: ControlProperty<number> = model.truckToCouple,
    public decoupling: ControlProperty<boolean> = model.decoupling,
    public coupling: ControlProperty<boolean> = model.coupling,
    public emissionStage: ControlProperty<EmissionStage> = model.emissionStage,
  ) {}
}

export class AllocationViewUliTruckInformationFormOutputModel extends AllocationViewUliTruckInformationBaseModel {
  loadingTypes: TruckLoadingType[] = [];

  constructor(params?: AllocationViewUliTruckInformationFormInputModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewUliTruckInformationFormInputModel extends AllocationViewUliTruckInformationBaseModel {
  loadingTypes: TruckLoadingType[] = [];

  constructor(params?: AllocationViewUliTruckInformationFormOutputModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
